import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function Mecanismo() {
  const fugas = ['cancelaciones sin control', 'agenda mal organizada', 'precios sin estructura', 'pacientes que no continúan'];
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-24 px-4 bg-slate-50" data-id="element-57">
      <div className="max-w-4xl mx-auto" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-59">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-red-100 text-red-600 mb-6" data-id="element-60">
            <span className="text-2xl" data-id="element-61">🔥</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#0f4c5c] mb-6 uppercase" data-id="element-62">
            NO ES FALTA DE PACIENTES. ES FALTA DE SISTEMA.
          </h2>
          <p className="text-xl md:text-2xl text-slate-700 font-medium max-w-2xl mx-auto" data-id="element-63">
            Podés tener pacientes… y aun así perder dinero todos los meses.
          </p>
        </motion.div>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-slate-100 relative overflow-hidden" data-id="element-64">
          <div className="absolute top-0 left-0 w-2 h-full bg-red-500" data-id="element-65"></div>

          <p className="text-xl font-bold text-slate-800 mb-6" data-id="element-66">
            Porque tu consultorio tiene fugas:
          </p>

          <div className="space-y-4 mb-10" data-id="element-67">
            {fugas.map((fuga, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-4" data-id="element-68">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-69" />
                <p className="text-lg text-slate-700" data-id="element-70">{fuga}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="text-center" data-id="element-71">
            <p className="text-2xl font-bold text-red-600 mb-8" data-id="element-72">
              👉 Sin sistema, el dinero se pierde.
            </p>

            <button onClick={scrollToCompra} className="bg-[#0f4c5c] hover:bg-[#1a3a4a] text-white font-bold py-4 px-8 rounded-full text-lg transition-transform hover:scale-105 shadow-lg w-full md:w-auto" data-id="element-73">
              QUIERO DEJAR DE PERDER DINERO
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}